// Slide decks associated with Object-Oriented Programming (OOP) sprint 3

import { list24500Sprint02 } from '../ActivityLists/AL24500Sprint02'
import { list24500Sprint03 } from '../ActivityLists/AL24500Sprint03'

import { xyz_n_1of4, xyz_n_2of4_PAaA, xyz_n_2of4, xyz_n_3of4_PAaA, xyz_n_3of4, xyz_n_4of4_PAaA, xyz_n_4of4 } from './SL00000Sprint00TTR'
import { orderedListSlide, submissionPercentage } from './SLSprint00'
import { breakoutStandard } from './SLSprint00'

// Object-Oriented Programming (OOP) sprint 3 global values.
const sprint = 3
const activityList = () => { return list24500Sprint03(sprint) }
const activityListPrevious = () => { return list24500Sprint02(sprint-1) }
const sprintAndActivityLists = { 'sprint': sprint, 'activityList': activityList, 'activityListPrevious': activityListPrevious }

// Session 1 of 4: Tuesday
const oop_3_1of4 = () => { return xyz_n_1of4(null, null, sprintAndActivityLists, null) }

// Session 2 of 4: Thursday
const completeThrough = 5
const oop_3_2of4_PAaA = xyz_n_2of4_PAaA(completeThrough, sprint)
const oop_3_2of4 = () => {
	const metricsSubmissionPercentage = () => {
		return submissionPercentage([
			{ name: 'Discussion', due:3, submitted:3 },
			{ name: 'Quiz', due:3, submitted:3 },
			{ name: 'Lab', due:3, submitted:3 },
			{ name: 'Reflection', due:3, submitted:3 }])
	}
	const retrospective = () => {
		return orderedListSlide('Class Retrospective',
			'Feedback from Assignments & Reflections', [
			`Perfect submission again... thank you!`,
			'Celebration?',
			'Lab assignments not graded/posted', 
			`If you are not where you want to be in the class after sprint ${sprint-1}, let’s set up a time to talk.`,
			`If you are not where you want to be in the class after sprint ${sprint}, you should consider dropping` ])
	}

	return xyz_n_2of4(oop_3_2of4_PAaA, oop_3_3of4_PAaA, sprintAndActivityLists, metricsSubmissionPercentage, retrospective)
}

// Session 3 of 4: Tuesday
export const breakoutRequirementsGUI = 'Graphical User Interfaces'
const breakoutGUI = () => {
	return breakoutStandard( 
		`${breakoutRequirementsGUI} Breakout`, 
		`In this breakout session on “${breakoutRequirementsGUI}” your team will discuss:`, [
		'AWT... What does that stand for?',
		'Swing, SWT, and JavaFX',
		'How is Android related to Java?',
		'Layout Managers in Java',
		'Class Inheritance vs. Composition vs. Interfaces' ])
}

const oop_3_3of4_PAaA = xyz_n_3of4_PAaA(8, sprint, breakoutRequirementsGUI)
const oop_3_3of4 = () => { return xyz_n_3of4(oop_3_3of4_PAaA, oop_3_4of4_PAaA, sprintAndActivityLists, breakoutGUI) } 

const oop_3_4of4_PAaA = xyz_n_4of4_PAaA(7, sprint)
const oop_3_4of4 = () => { return xyz_n_4of4(oop_3_4of4_PAaA, null, sprintAndActivityLists) }

export const oop_3_slidedeckTTR = [ oop_3_1of4, oop_3_2of4, oop_3_3of4, oop_3_4of4 ]